import { useState } from 'react'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

import Layout from "../../layouts/layout";
import MainPageLayout from '../../components/main-page-layout/mainPageLayout'
import { getSingleUser, updateSingleUsers } from '../../api/users'
import { useRequestProcessor } from '../../api/requestProcessor'
import Loading from '../../components/loading/loading'

const ViewUser = () => {

    const { Query, Mutate } = useRequestProcessor();



    const { user_id } = useParams();
    const [isActive, setIsActive] = useState(true)


    const [role, setRole] = useState([
        {
            name: "admin",
            label: "ادمین"
        },
        {
            name: "user",
            label: "کاربر عادی"
        },
    ])

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();

    const { data: fetchedData, isLoading, isError } = Query(
        ['getSingleUser', user_id],
        () => getSingleUser(user_id)
    );




    useEffect(() => {
        reset(fetchedData?.data);
        setIsActive(fetchedData?.data?.active)
    }, [fetchedData]);


    if (isLoading) return <Loading />
    return (
        <Layout>
            <MainPageLayout title={"تصحیح مشخصات کاربر " + fetchedData?.data?.name} backButton sectionTitle={"تصحیح مشخصات کاربر"} >
                <form className='flex flex-col'>
                    <div className="flex wsm:flex-col">
                        <div className='flex-col my-4 !w-full'>
                            <div className='flex flex-col my-3'>
                                <p className={`pr-3 pb-1 ${errors.name && "text-red-500"}`}>نام :</p>
                                <input disabled type="text" {...register("name", { required: true })} className='form-input !w-full' placeholder='نام' />
                            </div>
                            <div className='flex flex-col my-3'>
                                <p className={`pr-3 pb-1 ${errors.lastname && "text-red-500"}`}>نام خانوادگی:</p>
                                <input disabled type="text" {...register("lastname", { required: true })} className='form-input !w-full' placeholder='نام خانوادگی ' />
                            </div>
                            <div className='flex flex-col my-3'>
                                <p className={`pr-3 pb-1 ${errors.email && "text-red-500"}`}>ایمیل :</p>
                                <input disabled type="email" autoComplete="new-email" {...register("email")} className='form-input !w-full' placeholder='ایمیل' />
                            </div>
                            <div class="flex-col  w-full ">
                                <p>وضعیت کاربر :</p>
                                <div className="mx-10 items-center flex wsm:!mx-0 mt-2">
                                    <p>غیر فعال</p>
                                    <label class="relative inline-flex  cursor-pointer mx-2">
                                        <input disabled type="checkbox" value={isActive} onChange={(e) => { }} class="sr-only peer" />
                                        <div class={`w-11 h-6  rounded-full peer ${isActive ? "bg-sky-300" : "bg-gray-200"}  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all `}></div>
                                    </label>
                                    <p>فعال</p>
                                </div>
                            </div>
                        </div>
                        <div className="flex-col my-4 !w-full mr-2">
                            <div className='flex flex-col my-3'>
                                <p className={`pr-3 pb-1 ${errors.level && "text-red-500"}`}>نقش :</p>
                                <select disabled {...register("level", { required: true })} className="!w-full  border border-gray-500 py-2 px-[20px] rounded-[10px] focus:border-[#1976d2bf]" >
                                    {
                                        role?.map(el => (
                                            <option key={el.id} className="py-3" value={el.name} >{el.label}</option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div className='flex flex-col my-3'>
                                <p className={`pr-3 pb-1 ${errors.phone && "text-red-500"}`}>شماره تلفن:</p>
                                <input type="number" disabled autoComplete="new-phone" {...register("phone", { required: true, minLength: 11, maxLength: 11 })} className='form-input !w-full' placeholder='شماره ' />
                            </div>

                        </div>
                    </div>
                    {
                        fetchedData?.data?.tickets && fetchedData?.data?.tickets.length !== 0 &&
                        <table className="table-auto transition-all" >
                            <thead className="!py-2">
                                <tr className=" border-b border-black">
                                    <th className="py-3">#</th>
                                    <th className="py-3">آیدی سازنده</th>
                                    <th className="py-3">آیدی ورک شاپ</th>
                                    <th className="py-3">وضعیت</th>
                                </tr>
                            </thead>
                            {
                                !isLoading &&
                                <tbody>
                                    {
                                        fetchedData?.data?.tickets.map(el => (
                                            <tr key={el.id} className="text-[#575757] border-b border-[#d5d5d5] hover:bg-[#fafafa]"  >
                                                <td className="text-center py-5" >{el.id}</td>
                                                <td className="text-center py-5" > {el.creator_id}</td>
                                                <td className="text-center py-5" > {el.workshop_id}</td>
                                                <td className="text-center py-5" > {el.state ? "فعال" : "غیر فعال"}</td>
                                                {/* <td className="text-center py-5 " >
                                                    <div className="bg-[#2196f3] py-2 text-white rounded-[1rem]">
                                                        {el?.roles.length ? "سوپر ادمین" : "کاربر"}
                                                    </div>
                                                </td> */}

                                            </tr>
                                        ))
                                    }
                                </tbody>
                            }
                        </table>
                    }

                </form>
            </MainPageLayout>
        </Layout>
    )
}

export default ViewUser